// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GmEti","content":"styles_content__1uItu"};